import { render, staticRenderFns } from "./StepperTabItem.vue?vue&type=template&id=6863842c&"
import script from "./StepperTabItem.vue?vue&type=script&lang=js&"
export * from "./StepperTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports